import { FieldArray, Form, FormikProps } from "formik";
import { isNull } from "lodash";
import React from "react";
import { ReactElement } from "react";
import { ObjectSchema } from "yup";
export interface IDynamicForm {
    formikProps: FormikProps<any>;
    children: ReactElement;
    childrenProps?: any;
    formId: string;
    singleInicialValues?: any;
    formData?: { data: Array<any> };
    setFormData: React.Dispatch<React.SetStateAction<{ data: Array<any> }>>;
    validationSchema?: ObjectSchema<any>;
}

const DynamicForm = (props: IDynamicForm) => {
    const {
        formikProps,
        singleInicialValues = {},
        childrenProps = {},
        formData = { data: [] },
        setFormData = () => {},
        children = <></>,
        formId = "MyForm",
    } = props;

    const handleDataForm = (index: number | null, action: "DELETE" | "ADD") => {
        const currentData = formikProps.values.data;
        switch (action) {
            case "DELETE": {
                if (isNull(index)) break;
                if (!currentData[index].id) {
                    currentData.splice(index, 1);
                    formikProps.setValues({ data: currentData });
                } else {
                    currentData[index] = formData.data.find(
                        (data) => data.id == currentData[index].id
                    );
                    currentData[index].delete = true;
                    formikProps.setValues({ data: currentData });
                }
                setFormData({ data: currentData });
                break;
            }
            case "ADD": {
                if (isNull(index)) {
                    currentData.push({ ...singleInicialValues });
                    setFormData({ data: currentData });
                } else {
                    const copiedData = { ...currentData[index] };
                    if (copiedData.id) delete copiedData.id;
                    if (copiedData.draft) delete copiedData.draft;
                    currentData.push({ ...copiedData });
                    setFormData({ data: currentData });
                }
                break;
            }
            default:
                break;
        }
    };

    return (
        <Form id={formId}>
            <FieldArray
                name="data"
                render={() =>
                    formData.data.map((value: any, index: number) => {
                        return (
                            <React.Fragment key={index}>
                                {!value.delete && (
                                    <>
                                        {React.cloneElement(children, {
                                            ...childrenProps,
                                            indexOfTheForm: index,
                                            fieldArrayName: `data.${index}.`,
                                            formData: value,
                                            handleDataForm: (
                                                indexOfTheForm: number,
                                                action: "DELETE" | "ADD"
                                            ) => handleDataForm(indexOfTheForm, action),
                                        })}
                                    </>
                                )}
                            </React.Fragment>
                        );
                    })
                }
            />
        </Form>
    );
};

DynamicForm.propTypes = {};

export default DynamicForm;
